import { useState } from "react";

/**
 * Brand image: ivory shimmer while loading; on missing/broken source renders
 * the aubergine heart mark at low opacity on ivory. Never a broken-image icon.
 * Reserves aspect space via the parent's aspect-* class — no layout shift.
 */
export default function BrandImage({ src, alt = "", className = "", imgClassName = "", loading = "lazy", srcSet, sizes, testid }) {
  const [state, setState] = useState("loading");
  return (
    <div className={`relative overflow-hidden bg-ivory ${state === "loading" ? "shimmer" : ""} ${className}`} data-testid={testid}>
      {state !== "error" && src ? (
        <img
          src={src}
          {...(srcSet ? { srcSet, sizes: sizes || "100vw" } : {})}
          alt={alt}
          loading={loading}
          onLoad={() => setState("loaded")}
          onError={() => setState("error")}
          className={`h-full w-full object-cover transition-opacity duration-300 ${state === "loaded" ? "opacity-100" : "opacity-0"} ${imgClassName}`}
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <img src="/assets/brand/heart-aubergine.png" alt="" className="w-1/3 opacity-[0.12]" />
        </div>
      )}
    </div>
  );
}
